/* Tag paths are generated by Shopify Liquid. Only carry native query constraints;
   never filter cards in the browser or synthesize collection tag paths. */
(() => {
  document.addEventListener('keydown', (event) => {
    if (event.key !== ' ') return;
    const link = event.target.closest('[data-toys-choice] a[role="checkbox"]');
    if (!link) return;
    event.preventDefault();
    link.click();
  });
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-toys-filters] a');
    if (!link) return;
    const current = new URL(window.location.href);
    const destination = new URL(link.href, current);
    if (destination.origin !== current.origin) return;
    destination.search = '';
    for (const [key, value] of current.searchParams) {
      if (key === 'sort_by' || key.startsWith('filter.')) destination.searchParams.append(key, value);
    }
    link.href = destination.href;
    // Native tag filtering reloads the whole document. Resume the same mobile
    // submenu after that navigation, keeping Dawn's own back/Apply handlers.
    const mobileGroup = link.closest('#FacetFiltersFormMobile [data-toys-group]');
    if (mobileGroup?.dataset?.toysGroup) {
      try { window.sessionStorage.setItem('toys-filter-resume', JSON.stringify({path: destination.pathname, group: mobileGroup.dataset.toysGroup})); } catch (_) { /* Storage may be disabled; links still work. */ }
    }
  });
  window.addEventListener?.('load', () => {
    let resume;
    try {
      resume = JSON.parse(window.sessionStorage.getItem('toys-filter-resume'));
      window.sessionStorage.removeItem('toys-filter-resume');
    } catch (_) { return; }
    if (!resume || resume.path !== window.location.pathname || !window.matchMedia('(max-width: 749px)').matches) return;
    const group = [...document.querySelectorAll('#FacetFiltersFormMobile [data-toys-group]')].find(item => item.dataset.toysGroup === resume.group);
    if (!group) return;
    const drawer = group.closest('menu-drawer');
    drawer.querySelector('details > summary').click();
    window.setTimeout(() => group.querySelector('summary').click(), 100);
  });
})();
